<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc"><a href="#/ch01">Chapter 1. Political Brawls</a></p>
<p class="toct"><a href="#/ch01#sec1.1">Fighting with Words</a></p>
<p class="toct"><a href="#/ch01#sec1.2">Fighting with Fists</a></p>
<p class="toct"><a href="#/ch01#sec1.3">Fighting (Fatally) with Firearms</a></p>
<p class="toc"><span href="#/ch02" title="Link target outside of Sample">Chapter 2. Governors’ (Mis)Deeds</span></p>
<p class="toct"><span href="#/ch02#sec2.1" title="Link target outside of Sample">Joel Matteson and the Great Canal Scrip Scandal</span></p>
<p class="toct"><span href="#/ch02#sec2.2" title="Link target outside of Sample">William H. Bissell’s Duel, Disingenuousness and Debilitating Disease</span></p>
<p class="toc"><span href="#/ch03" title="Link target outside of Sample">Chapter 3. Sex, Slander and Fighting</span></p>
<p class="toct"><span href="#/ch03#sec3.1" title="Link target outside of Sample">Lovers, Brothels and Venereal Diseases</span></p>
<p class="toct"><span href="#/ch03#sec3.2" title="Link target outside of Sample">Slanderous Statements and Atrocious Accusations</span></p>
<p class="toct"><span href="#/ch03#sec3.3" title="Link target outside of Sample">Fighting Dirty</span></p>
<p class="toc"><span href="#/ch04" title="Link target outside of Sample">Chapter 4. Slavery in the Emancipator’s Hometown</span></p>
<p class="toct"><span href="#/ch04#sec4.1" title="Link target outside of Sample">Springfield’s Slaves and Indentured Servants</span></p>
<p class="toct"><span href="#/ch04#sec4.2" title="Link target outside of Sample">The Fugitive Slave Case</span></p>
<p class="toc"><span href="#/ch05" title="Link target outside of Sample">Chapter 5. Abraham Lincoln’s Scandal</span></p>
<p class="toct"><span href="#/ch05#sec5.1" title="Link target outside of Sample">The Poison Pen</span></p>
<p class="toct"><span href="#/ch05#sec5.2" title="Link target outside of Sample">The Duel</span></p>
<p class="toc"><span href="#/ch06" title="Link target outside of Sample">Chapter 6. Murder Most Foul</span></p>
<p class="toct"><span href="#/ch06#sec6.1" title="Link target outside of Sample">The Trailor Mystery: The Murder that Wasn’t</span></p>
<p class="toct"><span href="#/ch06#sec6.2" title="Link target outside of Sample">Bumped Off in the Backyard</span></p>
<p class="toct"><span href="#/ch06#sec6.3" title="Link target outside of Sample">A Shot in the Dark</span></p>
<p class="toct"><span href="#/ch06#sec6.4" title="Link target outside of Sample">Infanticide of an Illegitimate Child</span></p>
<p class="toct"><span href="#/ch06#sec6.5" title="Link target outside of Sample">A Dance Turns Deadly</span></p>
<p class="toc"><span href="#/ch07" title="Link target outside of Sample">Chapter 7. Civil War Shenanigans</span></p>
<p class="toct"><span href="#/ch07#sec7.1" title="Link target outside of Sample">Revelry and Riots</span></p>
<p class="toct"><span href="#/ch07#sec7.2" title="Link target outside of Sample">An Officer with a Hair-Trigger Temper</span></p>
<p class="toct"><span href="#/ch07#sec7.3" title="Link target outside of Sample">Shot by a Soldier in the Street</span></p>
<p class="toct"><span href="#/ch07#sec7.4" title="Link target outside of Sample">Lincoln’s Wartime Nepotism Gone Bad</span></p>
<p class="toc"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1"><span href="#/bibli" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b9eb17e2